import { Fragment } from 'react';

import { AgreementFormEnum, EscrowPartyTypeEnum } from 'src/graphql/schema';
import { useOnboardingStepSubmit, useStepSubmitHandler } from 'src/context/onboarding-step-submit';
import { RepresentativesContainer, withApiSubmitActions } from 'src/containers/Escrow/Representatives';

import { DepositorOrganization } from '.';

import { DepositorContextProvider, useDepositorContext } from '../model';

const Representatives = withApiSubmitActions(RepresentativesContainer, () => {
  const { depositor, escrowId, agreementType } = useDepositorContext();
  const { clearStepError } = useOnboardingStepSubmit();

  const clearErrorOnSignatory = ({ signatory }: { signatory?: boolean | null }) => {
    if (signatory) clearStepError();
  };

  return {
    role: EscrowPartyTypeEnum.Depositor,
    escrowId,
    escrowPartyId: depositor.id,
    contacts: depositor.contacts,
    canUpdate: depositor.policy.update,
    agreementType,
    onRepresentativeSaved: clearErrorOnSignatory,
  };
});

const DepositorDetails = () => {
  const { depositor } = useDepositorContext();

  const requireRepresentatives = async () => {
    if (!depositor.policy.update) return true;

    if (!depositor.contacts.length) return 'Add at least one representative to continue.';

    if (!depositor.contacts.some(({ signatory }) => signatory))
      return 'At least one representative must be designated as a signatory.';

    return true;
  };

  useStepSubmitHandler(requireRepresentatives);

  return (
    <Fragment>
      <DepositorOrganization />
      <Representatives />
    </Fragment>
  );
};

type Props = {
  depositorId: string;
  escrowId: string;
  agreementType: AgreementFormEnum;
};

const EscrowDepositorContainer = ({ depositorId, escrowId, agreementType }: Props) => {
  return (
    <DepositorContextProvider depositorId={depositorId} escrowId={escrowId} agreementType={agreementType}>
      <DepositorDetails />
    </DepositorContextProvider>
  );
};

export default EscrowDepositorContainer;
